export default "__VITE_ASSET__BqG_cxd0__"